import React, { useEffect } from 'react';
import { 
  useMeetingManager, 
  PreviewVideo, 
  useLocalVideo,  
  VideoTileGrid, 
  ContentShare, 
  useToggleLocalMute,
  useLocalAudioOutput,
  useContentShareControls} from 'amazon-chime-sdk-component-library-react';
import { MeetingSessionConfiguration } from 'amazon-chime-sdk-js';
import './ChimeSDK.css';
import Button from 'aws-northstar/components/Button';
import VideoCall from '@material-ui/icons/VideoCall';
import VolumeOff from '@material-ui/icons/VolumeOff';
import MicOff from '@material-ui/icons/MicOff';
import Share from '@material-ui/icons/Share';
import PlayArrow from '@material-ui/icons/PlayArrow';
import Grid from 'aws-northstar/layouts/Grid';


//******** change this to point to the correct Api Gateway URL **************************
const apiUrl = 'https://ysteku1s80.execute-api.us-east-1.amazonaws.com/Prod/meetingInfo'
//******** change this to point to the correct Api Gateway URL **************************

const MyApp = () => {
  const { toggleContentShare } = useContentShareControls();
  const meetingManager = useMeetingManager();
  const useMountEffect = (fun) => useEffect(fun, [])
  const queryString = window.location.search;
  console.log("QueryString:", queryString);
  const urlParams = new URLSearchParams(queryString);
  var user = urlParams.get('user');
  console.log("User...", user);
  
  

  async function getMeetingInfo() {
    console.log("Fetching", apiUrl)
    const response = await fetch(apiUrl);
    return await response.json()
  }

  const joinMeeting = async() => {

    // Fetch the meeting and attendee data
    const data = await getMeetingInfo(); 
    console.log("Data:", data);

    const meeting = data.Meeting;
    const attendee = data.Attendee;

    // Insert meeting and attendee info to join data
    const joinData = {
      meetingInfo: meeting,
      attendeeInfo: attendee,
    };
    const meetingSessionConfiguration = new MeetingSessionConfiguration(data.Meeting, data.Attendee);
    console.log('meeting session config: ' + JSON.stringify(meetingSessionConfiguration));
    console.log(joinData);
    console.log('Attendee info: ' + JSON.stringify(attendee));
    attendee.attendeeId = attendee.AttendeeId;
    console.log(JSON.stringify(attendee));
    // Use the join API to create a meeting session
    try {
        console.log('Try to join meeting session..');
        //await meetingManager.join(joinData);
        await meetingManager.join(meetingSessionConfiguration);
        console.log("Created meeting session:", joinData);    
    } catch (error) {
        console.log('Error joining meeting session!');
        console.error(error);
    }
    

    // At this point you can let users setup their devices, or start the session immediately
    await meetingManager.start();
    console.log("Meeting started");
  };
  
  const MyMeetingView = () => (
    <div>
      <Button className='buttons' variant="primary" icon={PlayArrow} iconAlign='left'  onClick={joinMeeting}>Join</Button>
      <Button className='buttons' variant="primary" icon={Share} iconAlign='left' onClick={toggleContentShare}>Toggle content share</Button>
      <MuteButton />
      <AudioOutButton />
      <MyChild />
      <div id = "video">
        <div id = "contentVideo">
          <ContentShare />
        </div>  
        <Grid item xs={8}>
        <div className ='gridVideo' style={{marginTop: '1rem', height: '30rem', width: '70rem', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', objectFit: 'contain'}}>
          <VideoTileGrid 
            layout = 'standard' 
            noRemoteVideoView ='No remote video'
            />
        </div>
        <div id ='previewVideo'>
          
        </div>
        </Grid>
      </div>
    </div>
  );


  const MyChild = () => {
    const { isVideoEnabled, toggleVideo } = useLocalVideo();

    return (
      <Button className='buttons' variant="primary" icon={VideoCall} iconAlign="left" onClick={toggleVideo}>
      {isVideoEnabled ? 'Stop your video' : 'Start your video'}
    </Button>
    );
  };

  const StartButton = () => {
    const { isVideoEnabled, toggleVideo } = useLocalVideo();
    return (
      <button onClick={toggleVideo}>
      {isVideoEnabled ? 'Stop your video' : 'Start your video'}
      </button>
    );
  };
  
  const MuteButton = () => {
    const { muted, toggleMute } = useToggleLocalMute();
    return (
      <Button className='buttons' variant="primary" icon={MicOff} iconAlign='left' onClick={toggleMute}>
        {muted ? 'Unmute myself' : 'Mute myself'}
      </Button>
    );
  };

  const AudioOutButton = () => {
    const { isAudioOn, toggleAudio } = useLocalAudioOutput();
    return (
      <Button className='buttons' variant="primary" icon={VolumeOff} iconAlign='left' onClick={toggleAudio}>
        {isAudioOn ? 'Audio Off' : 'Audio On'}
      </Button>
    );
  };

  return MyMeetingView();
};

export default MyApp;
